import { useState } from 'react';
import axios from 'axios';

const AUTH_BASE = process.env.REACT_APP_AUTH_API_URL
  || process.env.REACT_APP_API_URL
  || 'https://<api-id>.execute-api.us-east-1.amazonaws.com/prod';

export default function AuthForm({ onAuthenticated }) {
  const [step,       setStep]       = useState('register'); // 'register' | 'otp'
  const [fullName,   setFullName]   = useState('');
  const [email,      setEmail]      = useState('');
  const [mobile,     setMobile]     = useState('');
  const [otp,        setOtp]        = useState('');
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState(null);
  const [info,       setInfo]       = useState(null);

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true); setError(null); setInfo(null);
    try {
      const { data } = await axios.post(`${AUTH_BASE}/auth/register`, {
        fullName, email: email.trim().toLowerCase(), mobile,
      });
      if (data.success) {
        setInfo('OTP sent to your email. Enter it below.');
        setStep('otp');
      } else {
        setError(data.message || 'Registration failed');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true); setError(null);
    try {
      const { data } = await axios.post(`${AUTH_BASE}/auth/verify-otp`, {
        email: email.trim().toLowerCase(), otp,
      });
      if (data.success && data.session) {
        localStorage.setItem('biw_session', JSON.stringify(data.session));
        onAuthenticated(data.session);
      } else {
        setError(data.message || 'OTP verification failed');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'OTP verification failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.overlay}>
      <div style={s.card}>
        {/* Header */}
        <div style={s.header}>
          <span style={{ fontSize: 28 }}>🏭</span>
          <h2 style={s.title}>BIW Validation Portal</h2>
          <p style={s.subtitle}>Sign in to access design validation</p>
        </div>

        {step === 'register' && (
          <form onSubmit={handleRegister} style={s.form}>
            <Field label="Full Name" type="text" value={fullName}
              onChange={e => setFullName(e.target.value)} placeholder="John Smith" required />
            <Field label="Work Email" type="email" value={email}
              onChange={e => setEmail(e.target.value)} placeholder="eng@company.com" required />
            <Field label="Mobile" type="tel" value={mobile}
              onChange={e => setMobile(e.target.value)} placeholder="+1 234 567 8900" required />

            {error && <p style={s.error}>{error}</p>}
            {info  && <p style={s.info}>{info}</p>}

            <button type="submit" disabled={loading} style={{ ...s.btn, opacity: loading ? 0.6 : 1 }}>
              {loading ? 'Sending OTP…' : 'Send OTP'}
            </button>
          </form>
        )}

        {step === 'otp' && (
          <form onSubmit={handleVerifyOtp} style={s.form}>
            <p style={{ color: '#555', fontSize: 14, margin: '0 0 16px' }}>
              OTP sent to <strong>{email}</strong>
            </p>
            <Field label="Enter OTP" type="text" value={otp}
              onChange={e => setOtp(e.target.value)} placeholder="6-digit code"
              required maxLength={6} />

            {error && <p style={s.error}>{error}</p>}

            <button type="submit" disabled={loading} style={{ ...s.btn, opacity: loading ? 0.6 : 1 }}>
              {loading ? 'Verifying…' : 'Verify OTP'}
            </button>
            <button type="button" onClick={() => { setStep('register'); setError(null); }}
              style={s.backBtn}>
              ← Back
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

function Field({ label, ...props }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ display: 'block', fontSize: 13, color: '#444', marginBottom: 4 }}>{label}</label>
      <input style={s.input} {...props} />
    </div>
  );
}

const s = {
  overlay:  { minHeight: '100vh', background: '#f0f4f8', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  card:     { background: '#fff', borderRadius: 12, padding: '36px 40px', width: 380, boxShadow: '0 4px 24px rgba(0,0,0,0.10)' },
  header:   { textAlign: 'center', marginBottom: 28 },
  title:    { margin: '8px 0 4px', fontSize: 20, color: '#1a1a2e' },
  subtitle: { margin: 0, color: '#888', fontSize: 13 },
  form:     { display: 'flex', flexDirection: 'column' },
  input:    { width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' },
  btn:      { marginTop: 8, padding: '11px', background: '#0073bb', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 15, fontWeight: 600 },
  backBtn:  { marginTop: 8, padding: '8px', background: 'none', border: 'none', color: '#0073bb', cursor: 'pointer', fontSize: 13 },
  error:    { color: '#c00', fontSize: 13, margin: '4px 0' },
  info:     { color: '#27ae60', fontSize: 13, margin: '4px 0' },
};
